import * as CSS from 'csstype';
import {CargoSubtype, cargoSubtype} from '@ots-frontend/ots-data';
import {
  cargoSubtypeChemicalsColor,
  cargoSubtypeOilColor,
  cargoSubtypeWasteColor,
  cargoSubtypeWaterColor,
} from '../theme/colors';

/**
 * Returns the color for the cargo subtype.
 *
 * @param type the cargo subtype
 */
export const getCargoSubtypeColor = (
  type: CargoSubtype
): CSS.Property.Color => {
  switch (type) {
    case cargoSubtype.water:
      return cargoSubtypeWaterColor;
    case cargoSubtype.oil:
      return cargoSubtypeOilColor;
    case cargoSubtype.chemicals:
      return cargoSubtypeChemicalsColor;
    case cargoSubtype.waste:
      return cargoSubtypeWasteColor;
    case cargoSubtype.tank:
      return cargoSubtypeWasteColor;
    default:
      return '#58595B';
  }
};

export const getCargoSubtypeColorRefByType = (type: CargoSubtype): string => {
  switch (type) {
    case cargoSubtype.water:
      return "cargo-subtype-water";
    case cargoSubtype.oil:
      return "cargo-subtype-oil";
    case cargoSubtype.chemicals:
      return "cargo-subtype-chemicals";
    case cargoSubtype.waste:
      return "cargo-subtype-waste";
    case cargoSubtype.tank:
      return "cargo-subtype-tank";
    default:
      return "cargo-subtype-water";
  }
};
